import React from 'react'

const FieldError = ({ formik, name }) => {
  if (formik.submitCount === 0) return null

  const message = formik.errors[name]
  if (!message) return null

  return <span className="field-error">{message}</span>
}

export default FieldError